import { CSSProperties, useCallback } from "react";
import { prefix } from ".";

interface ISkeletonProps {
  loading?: boolean;
  rowWidth?: Array<string | number>;
  rowHeight?: Array<string | number>;
  row?: number;
  avatar?: boolean;
  className?: string;
  skeletonItemClass?: string;
  avatarClass?: string
}

const Skeleton = (props: ISkeletonProps) => {
  const { loading = true, className = '', row = 3, rowWidth = [], rowHeight = [], skeletonItemClass = 'baseClass', avatar, avatarClass = '' } = props;

  const lineStyle = useCallback(
    (i: number) => {
      let style: CSSProperties = {
        height: '24px',
      };

      if (rowWidth && rowWidth.length) {
        if (typeof rowWidth[i] === 'string') {
          style.width = rowWidth[i];
        } else if (typeof rowWidth[i] === 'number') {
          style.width = `${rowWidth[i]}px`;
        }
      }

      if (rowHeight && rowHeight.length) {
        if (typeof rowHeight[i] === 'string') {
          style.height = rowHeight[i];
        } else if (typeof rowHeight[i] === 'number') {
          style.height = `${rowHeight[i]}px`;
        }
      };

      return style;
    },
    [rowWidth, rowHeight]
  );

  return (
    loading ? (
      <div className={`${prefix} ${className}`}>
        {avatar && (
          <div
            className={`${prefix}-avatar ${avatarClass}`}
          />
        )}
        <div className={`${prefix}-content`}>
          {new Array(row).fill('').map((r, i) => {
            return (
              <div
                key={`${r}_${i}`}
                className={`${prefix}-content-item ${skeletonItemClass}`}
                style={lineStyle(i)}
              ></div>
            );
          })}
        </div>
      </div>
    ) : (
      <></>
    )
  )
};

export default Skeleton;